import React, { Component } from 'react';
import { Avatar, Button, CssBaseline, TextField, Typography, Container, withStyles, Snackbar} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MuiAlert from '@material-ui/lab/Alert';

import firebase from "../firebase"

const styles = theme => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    margin: {
        margin: theme.spacing(3, 0, 2),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        display: "block",
        marginTop: 20,
        margin: "auto",
        padding: 8,
        width: "50%",
    },
});

class Login extends Component{

    constructor(props) {
        super(props)

        this.state = {
            email: "",
            password: "",
            success: false,
            failure: false
        }

        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        })
    }

    handleSubmit = (event) => {
        event.preventDefault()
        console.log("called login")
        const { email, password } = this.state
        firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
            console.log(user)
            this.setState({
                success: true
            })
        }).catch((error) => {
            if (error != null) {
                console.log(error)
                this.setState({
                    failure: true
                })
            }
        })
    }

    handleClose = () => {
        this.setState({
            failure: false,
            success: false
        })
    }

    render() {
        const { classes } = this.props
        const { email, password, success, failure } = this.state
        return (
            <>
                <Snackbar open={success} onClose={this.handleClose} autoHideDuration={2000}>
                    <MuiAlert elevation={6} variant="filled" severity="success">
                        Success
                    </MuiAlert>
                </Snackbar>
                <Snackbar open={failure} onClose={this.handleClose} autoHideDuration={2000}>
                    <MuiAlert elevation={6} variant="filled" severity="error">
                    Invalid Credentials
                    </MuiAlert>
                </Snackbar>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sanvika Foodzo
                     </Typography>
                    <form className={classes.form} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                             autoComplete="off"
                             value={email}
                             onChange={this.handleChange('email')}
                            autoFocus
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                             id="password"
                             value={password}
                             onChange={this.handleChange('password')}
                            autoComplete="off"
                            />
                        <Button
                            onClick={this.handleSubmit}
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                             Log in
                        </Button>
                    </form>
                </div>
                </Container>
            </>
        );
    }
}

export default withStyles(styles)(Login);
